import { useTranslation } from 'react-i18next';
import { useReveal } from '../../hooks/useReveal';

export default function PRStatsBand() {
  const { t } = useTranslation();
  const ref = useReveal({ stagger: 0.07 });
  const stats = t('pr.stats_band', { returnObjects: true });

  return (
    <section ref={ref} style={{ background: 'var(--p2a-dark-panel)', borderBottom: '1px solid var(--p2a-dark-border)' }}>
      <div className="p2-container pr-stats" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', padding: '48px 0' }}>
        {stats.map((x, i) => (
          <div
            key={i}
            className="reveal"
            style={{
              padding: '0 32px',
              borderLeft: i ? '1px solid var(--p2a-dark-border)' : 'none',
            }}
          >
            <div className="mono" style={{ fontSize: 36, fontWeight: 600, color: 'var(--p2a-dark-fg-1)', letterSpacing: '-0.02em' }}>
              {x.v}
            </div>
            <div style={{ fontSize: 13, color: 'var(--p2a-dark-fg-3)', marginTop: 6 }}>{x.l}</div>
          </div>
        ))}
      </div>
      <style>{`
        @media (max-width: 820px) {
          .pr-stats { grid-template-columns: repeat(2, 1fr) !important; gap: 32px 0; }
          .pr-stats > div:nth-child(3) { border-left: none !important; }
        }
      `}</style>
    </section>
  );
}
